import React, { useEffect, useMemo, useState } from "react";
import SelectDropdown from "../../../components-react/SelectDropdown";
import BlackButton from "../../../common-components/BlackButton";
import GaugeChart from "react-gauge-chart";
import { useUpdateForm } from "../../../../data/Queries";
import { userUpdate, usersGetKey } from "../../../../data/ApiEndpoints";
// import { useSelector } from "react-redux";
// import { selectToken } from "../../../auth/auth.selector";
import { toast } from "react-toastify";
import Loader from "../../../ui/Loader";
import { BASE_URL } from "../../../../data/BaseUrl";

const PersonalInformation = ({
  userInfoData,
  ftProfileData,
  row,
  userData,
  setUserData,
}) => {
  const [formData, setFormData] = useState({});
  // const token = useSelector(selectToken);

  // const {
  //   data: userData,
  //   isLoading: isLoadingGet,
  //   isFetching: isFetchingGet,
  //   refetch: refetchGet,
  // } = useGetFetch({
  //   url: memberGet,
  //   isPage: "1",
  //   key: memberGetKey,
  //   filters,
  //   token,
  // });

  const { mutateAsync: updateUser, isLoading: isLoadingUser } = useUpdateForm({
    url: userUpdate,
    key: usersGetKey,
    token: userInfoData?.token,
  });
  const initialValues = {
    editCard: false,
    savedCard: true,
    showPassword: false,
  };
  const [bmiValues, setBmiValues] = useState({});
  const [values, setValues] = useState(initialValues);

  const getData = async (link) => {
    try {
      const url = `${BASE_URL}${link}`;
      const res = await fetch(url, {
        headers: {
          Authorization: `Bearer ${userInfoData?.token}`,
        },
      });

      const { data, status, message } = await res.json();

      if (status && data && data?.length > 0) {
        setUserData(data[0]);
        toast.success(message);
      } else {
        toast.error(message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  function calculateBMI() {
    try {
      const { ft, inch, kgs } = bmiValues;
      if (isNaN(ft) || isNaN(inch) || isNaN(kgs)) {
        return 0;
      } else {
        const heightInMeters = (ft * 12 + inch) * 0.0254;
        const bmi = (kgs / (heightInMeters * heightInMeters)).toFixed(1);
        if (isNaN(bmi)) {
          return;
        }
        return bmi;
      }
    } catch (error) {
      console.log(error);
    }
  }

  function getBMICategory(bmi) {
    const bmiRanges = [
      { name: "Underweight", min: 0, max: 18.5 },
      { name: "Healthy", min: 18.5, max: 24.9 },
      { name: "Overweight", min: 24.9, max: 29.9 },
      { name: "Obese", min: 30, max: 40 },
    ];

    for (let i = 0; i < bmiRanges.length; i++) {
      if (bmi >= bmiRanges[i].min && bmi <= bmiRanges[i].max) {
        return { rangeIndex: i, name: bmiRanges[i].name };
      }
    }

    return { rangeIndex: -1, name: "No Fitness Profile" };
  }

  const onClickHandler = (e, name) => {
    e.preventDefault();

    if (name === "edit-btn") {
      setValues({
        ...values,
        editCard: true,
        savedCard: false,
      });
    }

    if (name === "save-btn") {
      handleUpdateUser();
      setValues({
        ...values,
        editCard: false,
        savedCard: true,
      });
    }

    if (name === "show-password") {
      setValues({
        ...values,
        showPassword: !values.showPassword,
      });
    }
  };

  function getHeight(heightInCm) {
    const n = 30.48;

    const inches = Math.round((Number(heightInCm) % n) / 2.54);
    const feet = Math.floor(Number(heightInCm) / n);

    return {
      inches,
      feet,
    };
  }

  const genders = [
    { value: "male", label: "Male" },
    {
      value: "female",
      label: "Female",
    },
    { value: "others", label: "Other" },
  ];

  async function handleUpdateUser() {
    try {
      const row = userData;
      const body = {
        uid: row?.user_id,
        name: formData?.name,
        email: formData?.email,
        mobile: formData?.phone,
        status: row?.status,
        password: row?.password || "",
        new_password: row?.new_password || "",
        // bio: row?.bio,
        // is_whatsapp: row?.is_whatsapp,
        // account_type: row?.account_type,
        // gym_id: row?.gym_id,
        is_influencer: row?.is_influencer || 0,
        facebook_id: row?.facebook_id || 0,
        instagram_id: row?.instagram_id || 0,
        shift_i: row?.shift_idd,
      };

      const formdata = new FormData();

      Object.entries(body).forEach(([key, value]) => {
        formdata.append(key, value);
      });

      const { status, message } = await updateUser({ data: formdata });

      if (status) {
        toast.success(message);
      } else {
        toast.error(message);
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    try {
      const { data, status } = ftProfileData;
      const height = getHeight(data[0]?.height);
      if (status) {
        setBmiValues({
          ft: height?.feet || 0,
          inch: height?.inches || 0,
          kgs: Number(data[0]?.weight) || 0,
        });
      }
    } catch (error) {
      console.log(error);
    }
  }, [ftProfileData]);

  useEffect(() => {
    try {
      setFormData({
        name: userData?.name,
        email: userData?.email,
        phone: userData?.mobile,
        dob: "",
        address: "",
        password: "",
        gender: `${
          ftProfileData?.data && ftProfileData?.data[0]?.gender
        }`.toLowerCase(),
        // password: "",
      });
    } catch (error) {
      console.log(error);
    }
  }, [userData]);

  useEffect(() => {
    try {
      // refetchGet();
      if (row) {
        getData(`/member/?page=1&limit=10&search=${row?.member_mobile}`);
      }
    } catch (error) {
      console.log(error);
    }
  }, [row]);

  const bmiPercent = useMemo(() => {
    try {
      const bmi = Number(calculateBMI());
      const bmiRanges = [
        { min: 0, max: 18.5 },
        { min: 18.5, max: 24.9 },
        { min: 24.9, max: 29.9 },
        { min: 30, max: 40 },
      ];
      const arcLengthRatios = [0.2, 0.4, 0.2, 0.2];
      const { rangeIndex } = getBMICategory(bmi);

      if (rangeIndex !== -1) {
        const rangeWidth =
          bmiRanges[rangeIndex].max - bmiRanges[rangeIndex].min;
        const percentageWithinRange =
          (bmi - bmiRanges[rangeIndex].min) / rangeWidth;

        const isLastCategory = rangeIndex === arcLengthRatios.length - 1;
        const isBeyondLastCategory = bmi > bmiRanges[bmiRanges.length - 1].max;
        const percentage =
          isLastCategory || isBeyondLastCategory
            ? 1
            : arcLengthRatios[rangeIndex] * percentageWithinRange +
              arcLengthRatios
                .slice(0, rangeIndex)
                .reduce((acc, val) => acc + val, 0);

        return percentage;
      } else {
        return 0;
      }
    } catch (error) {
      console.log(error);
    }
  }, [bmiValues]);

  function loader() {
    try {
      if (!ftProfileData) {
        return true;
      }
      return false;
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className="cardsContainer">
      {loader() ? (
        <Loader />
      ) : (
        <>
          <div
            className="cardLeftRightContainer"
            style={{ height: values.editCard ? "780px" : "600px" }}
          >
            <div className="cardContainer cardBox">
              <div className="cardBoxTitle">
                <h3 className="cardBoxTitleText">Contact Information</h3>
              </div>
              {values.savedCard ? (
                <>
                  <div className="cardBoxContent">
                    <div className="cardBoxContentRow">
                      <div className="cardBoxContentRowItem">
                        <div className="cardBoxContentRowItemTitle">
                          <h4 className="cardBoxContentRowItemTitleText">
                            Name
                          </h4>
                        </div>
                        <div className="cardBoxContentRowItemContent">
                          <p className="cardBoxContentRowItemContentText">
                            {formData?.name}
                          </p>
                        </div>
                      </div>
                      <div className="grayLine"></div>
                      <div className="cardBoxContentRowItem">
                        <div className="cardBoxContentRowItemTitle">
                          <h4 className="cardBoxContentRowItemTitleText">
                            Email
                          </h4>
                        </div>
                        <div className="cardBoxContentRowItemContent">
                          <p className="cardBoxContentRowItemContentText">
                            {formData?.email}
                          </p>
                        </div>
                      </div>
                      <div className="grayLine"></div>
                      <div className="cardBoxContentRowItem">
                        <div className="cardBoxContentRowItemTitle">
                          <h4 className="cardBoxContentRowItemTitleText">
                            Phone number
                          </h4>
                        </div>
                        <div className="cardBoxContentRowItemContent">
                          <p className="cardBoxContentRowItemContentText">
                            {formData?.phone}
                          </p>
                        </div>
                      </div>
                      {/* <div className="grayLine"></div> */}
                      {/* <div className="cardBoxContentRowItem">
                        <div className="cardBoxContentRowItemTitle">
                          <h4 className="cardBoxContentRowItemTitleText">
                            DOB
                          </h4>
                        </div>
                        <div className="cardBoxContentRowItemContent">
                          <p className="cardBoxContentRowItemContentText">
                            {formData?.dob || "N/A"}
                          </p>
                        </div>
                      </div> */}
                      {/* <div className="grayLine"></div>
                      <div className="cardBoxContentRowItem">
                        <div className="cardBoxContentRowItemTitle">
                          <h4 className="cardBoxContentRowItemTitleText">
                            Address
                          </h4>
                        </div>
                        <div className="cardBoxContentRowItemContent">
                          <p className="cardBoxContentRowItemContentText">
                            {formData?.address || "N/A"}
                          </p>
                        </div>
                      </div> */}
                      <div className="grayLine"></div>
                      <div className="cardBoxContentRowItem">
                        <div className="cardBoxContentRowItemTitle">
                          <h4 className="cardBoxContentRowItemTitleText">
                            Gender
                          </h4>
                        </div>
                        <div className="cardBoxContentRowItemContent">
                          <p className="cardBoxContentRowItemContentText capitalise-k">
                            {(formData?.gender &&
                              formData?.gender !== "undefined" &&
                              formData?.gender) ||
                              "N/A"}
                          </p>
                        </div>
                      </div>
                      {/* <div className="grayLine"></div> */}
                      {/* <div className="cardBoxContentRowItem">
                        <div className="cardBoxContentRowItemTitle">
                          <h4 className="cardBoxContentRowItemTitleText">
                            Password
                          </h4>
                        </div>
                        <div className="iconInput">
                          <div className="cardBoxContentRowItemContent">
                            {values.showPassword ? (
                              <p className="cardBoxContentRowItemContentText"></p>
                            ) : (
                              <p className="cardBoxContentRowItemContentText">
                                ***********
                              </p>
                            )}
                          </div>
                          <button
                            onClick={(e) => onClickHandler(e, "show-password")}
                          >
                            {values.showPassword ? (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-eye-slash"
                                viewBox="0 0 16 16"
                              >
                                <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z" />
                                <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z" />
                                <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z" />
                              </svg>
                            ) : (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-eye"
                                viewBox="0 0 16 16"
                              >
                                <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                                <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                              </svg>
                            )}
                          </button>
                        </div>
                      </div>
                      <div className="grayLine"></div> */}
                    </div>
                  </div>
                  <div className="cardBoxButton px-2 py-5">
                    <BlackButton
                      btnName="Edit Profile"
                      onClickBtn={(e) => onClickHandler(e, "edit-btn")}
                    />
                  </div>
                </>
              ) : (
                <>
                  <div className="cardBoxContent">
                    <div className="cardBoxContentRow">
                      <div className="cardBoxContentRowItem">
                        <div className="cardBoxContentRowItemTitle">
                          <h4 className="cardBoxContentRowItemTitleText">
                            Name
                          </h4>
                        </div>
                        <div className="cardBoxContentRowItemContent">
                          <input
                            type="text"
                            className="cardBoxContentRowItemContentText"
                            value={formData?.name}
                            onChange={(e) =>
                              setFormData({ ...formData, name: e.target.value })
                            }
                          />
                        </div>
                      </div>
                      <div className="grayLine"></div>
                      <div className="cardBoxContentRowItem">
                        <div className="cardBoxContentRowItemTitle">
                          <h4 className="cardBoxContentRowItemTitleText">
                            Email
                          </h4>
                        </div>
                        <div className="cardBoxContentRowItemContent">
                          <input
                            type="email"
                            className="cardBoxContentRowItemContentText"
                            value={formData?.email}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                email: e.target.value,
                              })
                            }
                          />
                        </div>
                      </div>
                      <div className="grayLine"></div>
                      <div className="cardBoxContentRowItem">
                        <div className="cardBoxContentRowItemTitle">
                          <h4 className="cardBoxContentRowItemTitleText">
                            Phone number
                          </h4>
                        </div>
                        <div className="cardBoxContentRowItemContent">
                          <input
                            type="number"
                            className="cardBoxContentRowItemContentText"
                            value={formData?.phone}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                phone: e.target.value,
                              })
                            }
                          />
                        </div>
                      </div>
                      {/* <div className="grayLine"></div>
                      <div className="cardBoxContentRowItem">
                        <div className="cardBoxContentRowItemTitle">
                          <h4 className="cardBoxContentRowItemTitleText">
                            DOB
                          </h4>
                        </div>
                        <div className="cardBoxContentRowItemContent">
                          <input
                            type="date"
                            className="cardBoxContentRowItemContentText"
                            value={formData?.dob}
                            onChange={(e) =>
                              setFormData({ ...formData, dob: e.target.value })
                            }
                          />
                        </div>
                      </div> */}
                      {/* <div className="grayLine"></div>
                      <div className="cardBoxContentRowItem">
                        <div className="cardBoxContentRowItemTitle">
                          <h4 className="cardBoxContentRowItemTitleText">
                            Address
                          </h4>
                        </div>
                        <div className="cardBoxContentRowItemContent">
                          <textarea
                            className="cardBoxContentRowItemContentText"
                            value={formData?.address}
                            disabled
                          ></textarea>
                        </div>
                      </div> */}
                      <div className="grayLine"></div>
                      <div className="cardBoxContentRowItem">
                        <div className="cardBoxContentRowItemTitle">
                          <h4 className="cardBoxContentRowItemTitleText">
                            Gender
                          </h4>
                        </div>
                        <div className="cardBoxContentRowItemContent">
                          <div className="commonWrapper">
                            <SelectDropdown
                              options={genders}
                              selectedOption={genders.find(
                                (gender) => gender.value === formData?.gender
                              )}
                              setSelectedOption={(selectedValue) =>
                                setFormData({
                                  ...formData,
                                  gender: selectedValue?.value,
                                })
                              }
                              name="Select Gender"
                            />
                          </div>
                        </div>
                      </div>
                      {/* <div className="grayLine"></div>
                      <div className="cardBoxContentRowItem">
                        <div className="cardBoxContentRowItemTitle">
                          <h4 className="cardBoxContentRowItemTitleText">
                            Password
                          </h4>
                        </div>
                        <div className="iconInput">
                          <div className="cardBoxContentRowItemContent">
                            {values.showPassword ? (
                              <input
                                type="text"
                                className="cardBoxContentRowItemContentText"
                                disabled
                                value={formData?.password}
                              />
                            ) : (
                              <input
                                type="password"
                                className="cardBoxContentRowItemContentText"
                                disabled
                                value={formData?.password}
                              />
                            )}
                          </div>

                          <button
                            onClick={(e) => onClickHandler(e, "show-password")}
                          >
                            {values.showPassword ? (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-eye-slash"
                                viewBox="0 0 16 16"
                              >
                                <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z" />
                                <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z" />
                                <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z" />
                              </svg>
                            ) : (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-eye"
                                viewBox="0 0 16 16"
                              >
                                <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                                <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                              </svg>
                            )}
                          </button>
                        </div>
                      </div> */}
                      <div className="grayLine"></div>
                    </div>
                  </div>
                  <div className="cardBoxButton">
                    <BlackButton
                      btnName="Save Profile"
                      onClickBtn={(e) => onClickHandler(e, "save-btn")}
                    />
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="cardLeftRightContainer">
            <div className="cardContainer cardBox">
              <div className="cardBoxTitle">
                <h3 className="cardBoxTitleText">Body Stats</h3>
              </div>
              {bmiValues ? (
                <div className="cardBoxContent">
                  <div className="inputsContainer">
                    <div className="heightWeight height">
                      <label htmlFor="height">Height</label>

                      <div className="inputs">
                        <div className="cardBoxContentRowItemContent">
                          <input
                            value={bmiValues?.ft}
                            name="ft"
                            disabled
                            // onChange={(e) => setBmiData(e)}
                          />
                          <span className="">| ft</span>
                        </div>

                        <div className="cardBoxContentRowItemContent">
                          <input
                            value={bmiValues?.inch}
                            name="inch"
                            // onChange={(e) => setBmiData(e)}
                            disabled
                          />
                          <span className="">| inch</span>
                        </div>
                      </div>
                    </div>
                    <div className="heightWeight weight">
                      <label htmlFor="height" className="">
                        Weight
                      </label>

                      <div className="inputs">
                        <div className="cardBoxContentRowItemContent">
                          <input
                            value={bmiValues?.kgs}
                            disabled
                            name="kgs"
                            // onChange={(e) => setBmiData(e)}
                          />
                          <span className="">| kgs</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="bmiContainer">
                    <p className="name">Your BMI</p>

                    {isLoadingUser ? (
                      <Loader />
                    ) : (
                      <div className="bmiBox">
                        <div className="bmiGraph w-full-k">
                          <GaugeChart
                            id="bmi-chart"
                            arcsLength={[0.2, 0.4, 0.2, 0.2]}
                            colors={[
                              "#bcbbf7",
                              "#7ad34a",
                              "#e2dd63",
                              "#f13434",
                            ]}
                            percent={bmiPercent}
                            needleColor="#252525"
                            needleBaseColor="#252525"
                            animate={false}
                            arcWidth={0.4}
                            nrOfLevels={1}
                            textColor={"#252525"}
                            arcPadding={0}
                            cornerRadius={3}
                            hideText={true}
                          />
                          <div className="flex-k flex-col-k js-center-k items-center-k">
                            <p className="dark-text bold-text fs-4 lh-1">
                              {calculateBMI()}
                            </p>
                            <p className="text-muted">
                              {getBMICategory(calculateBMI())?.name || "N/A"}
                            </p>
                          </div>
                        </div>
                        <div className="bmiLegends">
                          <div className="grayLine"></div>

                          <div className="bmiLegendsItemContainer">
                            <div className="bmiLegendsItem">
                              <div className="bmiLegendsItemColor blue"></div>
                              <div className="calculations">
                                <p className="bmiLegendsItemText">
                                  Underweight
                                </p>
                                <span className="bmiResult">
                                  Less than 18.5
                                </span>
                              </div>
                            </div>
                            <div className="bmiLegendsItem">
                              <div className="bmiLegendsItemColor green"></div>
                              <div className="calculations">
                                <p className="bmiLegendsItemText">Healthy</p>
                                <span className="bmiResult">18.5-24.9</span>
                              </div>
                            </div>
                            <div className="bmiLegendsItem">
                              <div className="bmiLegendsItemColor orange"></div>
                              <div className="calculations">
                                <p className="bmiLegendsItemText">Overweight</p>
                                <span className="bmiResult">25.0-29.9</span>
                              </div>
                            </div>
                            <div className="bmiLegendsItem">
                              <div className="bmiLegendsItemColor red"></div>
                              <div className="calculations">
                                <p className="bmiLegendsItemText">Obese</p>
                                <span className="bmiResult">
                                  30.0 or higher
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                <div className="flex-k js-center-k w-full-k items-center-k my-6-k">
                  <span>No BMI data found!</span>
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default PersonalInformation;
